import {TextField} from '@hconnect/common/components'
import {CardBox} from '@hconnect/uikit/src/lib2'
import {Stack} from '@mui/material'
import {useFormContext} from 'react-hook-form'

import {ChecklistStepSection} from '../../components'
import {HROC_CHECKLIST_FORM_WIDTH_IN_PX} from '../../consts'
import {useWidgetTranslation} from '../../hooks'
import type {KilnCheckSheetHousekeepingSectionFormValues} from '../../types'
import {StepFormActionsContainer} from '../StepFormActionsContainer'

type Props = {
  readOnly?: boolean
}

export const HousekeepingSectionFields = ({readOnly = false}: Props) => {
  const {control} = useFormContext<KilnCheckSheetHousekeepingSectionFormValues>()
  const {t} = useWidgetTranslation()

  return (
    <CardBox width={{xs: '100%', md: HROC_CHECKLIST_FORM_WIDTH_IN_PX}}>
      <Stack spacing={2}>
        <ChecklistStepSection title={t('kilnCheckSheet.label.lancingFloors')}>
          <TextField
            name="lancingFloorsTimeCleaned"
            label={t('kilnCheckSheet.label.lancingFloorsTimeCleaned')}
            optional
            control={control}
            readOnly={readOnly}
          />
          <TextField
            name="lancingFloorsComment"
            label={t('kilnCheckSheet.label.lancingFloorsComment')}
            optional
            control={control}
            readOnly={readOnly}
          />
        </ChecklistStepSection>
        <ChecklistStepSection title={t('kilnCheckSheet.label.coolerFloor')}>
          <TextField
            name="coolerFloorTimeCleaned"
            label={t('kilnCheckSheet.label.coolerFloorTimeCleaned')}
            optional
            control={control}
            readOnly={readOnly}
          />
          <TextField
            name="coolerFloorTimeComment"
            label={t('kilnCheckSheet.label.coolerFloorTimeComment')}
            optional
            control={control}
            readOnly={readOnly}
          />
        </ChecklistStepSection>
        <ChecklistStepSection title={t('kilnCheckSheet.label.burnerFloor')}>
          <TextField
            name="burnerFloorTimeCleaned"
            label={t('kilnCheckSheet.label.burnerFloorTimeCleaned')}
            optional
            control={control}
            readOnly={readOnly}
          />
          <TextField
            name="burnerFloorTimeComment"
            label={t('kilnCheckSheet.label.burnerFloorTimeComment')}
            optional
            control={control}
            readOnly={readOnly}
          />
        </ChecklistStepSection>
        <ChecklistStepSection title={t('kilnCheckSheet.label.shiftExpectationAreas')}>
          <TextField
            name="shiftExpectationAreasTimeCleaned"
            label={t('kilnCheckSheet.label.shiftExpectationAreasTimeCleaned')}
            optional
            control={control}
            readOnly={readOnly}
          />
          <TextField
            name="shiftExpectationComment"
            label={t('kilnCheckSheet.label.shiftExpectationComment')}
            optional
            control={control}
            readOnly={readOnly}
          />
        </ChecklistStepSection>
        <ChecklistStepSection title={t('kilnCheckSheet.label.coolerRoofAtHood')}>
          <TextField
            name="coolerRoofAtHoodTimeCleaned"
            label={t('kilnCheckSheet.label.coolerRoofAtHoodTimeCleaned')}
            optional
            control={control}
            readOnly={readOnly}
          />
          <TextField
            name="coolerRoofAtHoodComment"
            label={t('kilnCheckSheet.label.coolerRoofAtHoodComment')}
            optional
            control={control}
            readOnly={readOnly}
          />
        </ChecklistStepSection>
        <StepFormActionsContainer />
      </Stack>
    </CardBox>
  )
}
